import { ColDef, ICellRendererParams } from "ag-grid-community";
import { TypographyWithTooltip } from "@/components/common/TypographyWithTooltip";

export const resourceTotalCpuColumnDef: ColDef = {
  field: "resource.total_cpu",
  headerName: "Total CPU",
  cellRenderer: ({ data }: ICellRendererParams) => {
    const resource = data?.resource;

    if (!resource) {
      return null;
    }

    return (
      <TypographyWithTooltip
        variant="body2"
        title={`${resource.total_cpu} Core`}
      />
    );
  },
};
